import DocIcon from "../../assets/img/document.svg";
import ImageIcon from "../../assets/img/image.svg";

export const MASTER_FILTER_KEYS = {
    project: [
        { label: "Projects", key: "projects", paramKey: "project_ids" },
        { label: "Region", key: "regions", paramKey: "region_ids" },
        { label: "Site", key: "sites", paramKey: "site_ids" },
        { label: "Building Types", key: "building_types", paramKey: "building_types" },
        { label: "Buildings", key: "buildings", paramKey: "building_ids" },
        { label: "MFP", key: "fmp", paramKey: "fmp" },
        { label: "Capital Request", key: "infrastructure_requests", paramKey: "infrastructure_requests" },
        { label: "Additions", key: "additions", paramKey: "addition_ids" },
        { label: "FCI", key: "fci", paramKey: "color_scale" },
        { label: "Responsibility", key: "responsibility", paramKey: "responsibility_ids" },
        { label: "Trade (For Trade, System & Sub-System)", key: "trades", paramKey: "trade_ids" },
        { label: "System (For System & Sub-System)", key: "system", paramKey: "system_ids" },
        { label: "Sub-System (For Sub-System)", key: "subsystem", paramKey: "subsystem_ids" },
        { label: "Primary Uses", key: "building_use", paramKey: "primary_use" },
        { label: "Secondary Uses", key: "secondary_use", paramKey: "secondary_use" },
        { label: "Sectors", key: "sectors", paramKey: "sectors" },
        { label: "Internal Groups", key: "internal_groups", paramKey: "internal_groups" },
        { label: "Divisions", key: "division", paramKey: "division" },
        { label: "Floor", key: "floors", paramKey: "floor_ids" },
        { label: "Addition", key: "additions", paramKey: "addition_ids" }
    ],
    energy_mng: [
        { label: "Region", key: "energy_mng_regions", paramKey: "region_ids" },
        { label: "Site", key: "energy_mng_sites", paramKey: "site_ids" },
        { label: "Building Types", key: "energy_mng_building_types", paramKey: "building_types" },
        { label: "Buildings", key: "energy_mng_buildings", paramKey: "building_ids" },
        { label: "Years", key: "energy_mng_years", paramKey: "years" }
    ],
    assets: [
        { label: "Region", key: "asset_regions", paramKey: "region_ids" },
        { label: "Site", key: "asset_sites", paramKey: "site_ids" },
        { label: "Buildings", key: "asset_buildings", paramKey: "building_ids" }
    ],
    smart_report_list_filter: [
        { label: "Clients", key: "clients", paramKey: "client_ids" },
        { label: "Projects", key: "projects", paramKey: "project_ids" },
        { label: "Users", key: "users", paramKey: "exportby_user_ids" }
    ],
    smart_report_properties_list_filter: [
        { label: "Clients", key: "clients", paramKey: "client_ids" },
        { label: "Projects", key: "projects", paramKey: "project_ids" },
        { label: "Users", key: "users", paramKey: "exportby_user_ids" }
    ],
    smart_task_manager_list_filter: [{ label: "Clients", key: "clients", paramKey: "client_ids" }],
    dynamic_table_list_filter: [
        { label: "Clients", key: "clients", paramKey: "client_ids" },
        { label: "Projects", key: "projects", paramKey: "project_ids" }
    ],
    documents: [{ label: "Clients", key: "clients", paramKey: "client_ids" }]
};

export const MASTER_FILTER_ROWS = {
    project: [1, 2, 3, 4],
    energy_mng: [1],
    assets: [1]
};

export const CHART_ITEMS = {
    project: {
        regions: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        sites: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        buildings: {
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            hasConfig: true,
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        additions: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        building_type: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        sorted_recom: {
            hasConfig: true,
            isVisible: true,
            defaultValue: {
                band1: {
                    is_soft_cost: false,
                    mfilter: {},
                    type: ["building"],
                    name: "Sorted Recommendation"
                }
            }
        },
        criticality: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        condition: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        categories: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        funding_sources: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        priorities: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        trades: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        system: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true,
                normal_recom: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                normal_recom: { band1: { mfilter: {}, remove_section_break: false }, name: "Recommendations", config_filter: {} },
                combination: false,
                remove_tbl_section_break: false
            }
        },
        subsystem: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        responsibilities: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        capital_type: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        EFCI: {
            hasConfig: true,
            config: {
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                detailed_view: {
                    chart_type: ["line_column_2d"],
                    config: {
                        sort_by: { name: "asc" }
                    }
                }
            }
        },
        energy_band: {
            hasConfig: true,
            isVisible: true,
            defaultValue: ""
        },
        water_band: {
            hasConfig: false,
            isVisible: true,
            defaultValue: ""
        },
        asset_band: {
            hasConfig: true,
            isVisible: true,
            defaultValue: { table_view: "", remove_tbl_section_break: false }
        },
        // building_report1: {
        //     hasConfig: true,
        //     isVisible: true,
        //     defaultValue: { band1: { mfilter: {}, name: "BBI/Stoplight Chart" } }
        // },
        // addition_report1: {
        //     hasConfig: true,
        //     isVisible: true,
        //     defaultValue: { band1: { mfilter: {}, bai_report: true, stop_light_report: false, name: "BAI" } }
        // },
        // site_report1: {
        //     hasConfig: true,
        //     isVisible: true,
        //     defaultValue: { band1: { mfilter: {}, bsi_report: true, stop_light_report: false, name: "BSI/Stoplight Chart" } }
        // },
        filter_report1: {
            hasConfig: false,
            isVisible: true,
            name: "Master Filters",
            band1: {
                mfilter: {}
            }
        },
        recommendation_status: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        building_addition_sf: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: {
                    chart_type: ["donut_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        },
        table_of_contents: {
            name: "TABLE OF CONTENTS",
            remove_section_break: false,
            custom_heading_props: {
                bold: true,
                color: "003f2d",
                font_size: 20,
                font_id: "",
                bg_color: "ffffff",
                alignment: "center",
                cell_margin: {
                    top: 0.04,
                    left: 0.04,
                    right: 0.04,
                    bottom: 0.04
                }
            },
            structured_heading: {}
        },
        project_cost: {
            hasConfig: true,
            config: {
                table_view: true,
                summary_view: true,
                detailed_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                show_columns: {
                    setting: true,
                    actual: true,
                    Setting: {
                        percentage: true,
                        value: true
                    },
                    Actual: {
                        percentage: true,
                        value: true
                    }
                },
                summary_view: {
                    chart_type: ["pie_3d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    remove_section_break: false,
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                },
                remove_tbl_section_break: false
            }
        }
    },
    assets: {
        asset_band: {
            hasConfig: true,
            isVisible: true,
            defaultValue: { table_view: "" }
        },
        end_servicelife_year_condition: {
            hasConfig: false,
            // config: {
            //     table_view: true,
            //     summary_view: true,
            //     detailed_view: true
            // },
            isVisible: true,
            defaultValue: { table_view: "", detailed_view: { chart_type: ["stacked_column_2d", "stacked_column_3d"] } }
        },
        asset_age_by_condition: {
            hasConfig: false,
            isVisible: true,
            defaultValue: { table_view: "", detailed_view: { chart_type: ["stacked_column_2d", "stacked_column_3d"] } }
        },
        asset_capital_spending_plan: {
            hasConfig: false,
            isVisible: true,
            defaultValue: {
                table_view: "",
                summary_view: { chart_type: ["pie_2d", "pie_3d"] },
                detailed_view: { chart_type: ["stacked_column_2d", "stacked_column_3d"] }
            }
        },
        asset_system_facility: {
            hasConfig: false,
            isVisible: true,
            defaultValue: { table_view: "", detailed_view: { chart_type: ["stacked_column_2d", "stacked_column_3d"] } }
        }
    },
    energy_mng: {
        em_eui_building_breakdown: {
            hasConfig: true,
            config: {
                // summary_view: true,
                detailed_view: true
                // table_view: true
            },
            isVisible: true,
            defaultValue: {
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                }
            }
        },
        em_eci_building_breakdown: {
            hasConfig: true,
            config: {
                // summary_view: true,
                detailed_view: true
                // table_view: true
            },
            isVisible: true,
            defaultValue: {
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                }
            }
        },
        bld_brkdown_energy_usage: {
            hasConfig: true,
            config: {
                summary_view: true
                // detailed_view: true,
                // table_view: true
            },
            isVisible: true,
            defaultValue: {
                summary_view: {
                    chart_type: ["pie_2d"],
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                }
            }
        },
        em_eui_site_brkdown_energy_use: {
            hasConfig: true,
            config: {
                // summary_view: true,
                detailed_view: true
                // table_view: true
            },
            isVisible: true,
            defaultValue: {
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                }
            }
        },
        em_eui_energy_usage: {
            hasConfig: true,
            config: {
                summary_view: true
                // detailed_view: true,
                // table_view: true
            },
            isVisible: true,
            defaultValue: {
                summary_view: {
                    chart_type: ["pie_2d"],
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                }
            }
        },
        bld_brkdown_energy_cost: {
            hasConfig: true,
            isVisible: true,
            config: {
                summary_view: true
            },
            defaultValue: {
                summary_view: {
                    chart_type: ["pie_2d"],
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                }
            }
        },
        em_eci_site_cost: {
            hasConfig: true,
            isVisible: true,
            config: {
                detailed_view: true
            },
            defaultValue: {
                detailed_view: {
                    chart_type: ["stacked_column_2d"],
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                }
            }
        },
        em_eci_energy_cost: {
            hasConfig: true,
            isVisible: true,
            config: {
                summary_view: true
            },
            defaultValue: {
                summary_view: {
                    chart_type: ["pie_2d", "pie_3d"],
                    config: {
                        legend: true,
                        color_legend: true,
                        header: true,
                        total: true,
                        sort_by: { name: "asc" }
                    }
                }
            }
        },
        monthly_electricity_cost: {
            hasConfig: true,
            isVisible: true,
            config: {
                detailed_view: true
            },
            detailed_view: {
                chart_type: ["stacked_column_2d"],
                config: {
                    legend: true,
                    color_legend: true,
                    header: true,
                    total: true,
                    sort_by: { name: "asc" }
                }
            }
        },
        monthly_gas_cost: {
            hasConfig: true,
            isVisible: true,
            config: {
                detailed_view: true
            },
            detailed_view: {
                chart_type: ["stacked_column_2d"],
                config: {
                    legend: true,
                    color_legend: true,
                    header: true,
                    total: true,
                    sort_by: { name: "asc" }
                }
            }
        },
        monthly_total_energy_cost: {
            hasConfig: true,
            isVisible: true,
            config: {
                detailed_view: true
            },
            detailed_view: {
                chart_type: ["stacked_column_2d"],
                config: {
                    legend: true,
                    color_legend: true,
                    header: true,
                    total: true,
                    sort_by: { name: "asc" }
                }
            }
        },
        monthly_electricity_usage: {
            hasConfig: true,
            isVisible: true,
            config: {
                detailed_view: true
            },
            detailed_view: {
                chart_type: ["stacked_column_2d"],
                config: {
                    legend: true,
                    color_legend: true,
                    header: true,
                    total: true,
                    sort_by: { name: "asc" }
                }
            }
        },
        monthly_gas_usage: {
            hasConfig: true,
            isVisible: true,
            config: {
                detailed_view: true
            },
            detailed_view: {
                chart_type: ["stacked_column_2d"],
                config: {
                    legend: true,
                    color_legend: true,
                    header: true,
                    total: true,
                    sort_by: { name: "asc" }
                }
            }
        },
        monthly_total_energy_usage: {
            hasConfig: true,
            isVisible: true,
            config: {
                detailed_view: true
            },
            detailed_view: {
                chart_type: ["stacked_column_2d"],
                config: {
                    legend: true,
                    color_legend: true,
                    header: true,
                    total: true,
                    sort_by: { name: "asc" }
                }
            }
        },
        energy_band: {
            hasConfig: false,
            isVisible: true,
            defaultValue: ""
        },
        water_band: {
            hasConfig: false,
            isVisible: true,
            defaultValue: ""
        }
    }
};

export const CHART_DATA_VIEWS = ["summary_view", "detailed_view", "table_view", "normal_recom"];
export const SMART_CHART_TAB_VIEWS = [
    { key: "reporttemplates", label: "Report Templates", url: "/smartcharts/reporttemplates" },
    { key: "reports", label: "Reports", url: "/smartcharts/reports" },
    { key: "corereports", label: "Core Reports", url: "/smartcharts/corereports", permissionKey: "core_report" },
    { key: "taskmanager", label: "Task Manager", url: "/smartcharts/taskmanager", role: "admin" },
    { key: "documents", label: "User Documents", url: "/smartcharts/documents", isButtonTab: true, icon: DocIcon, class: "btn-doc mr-2" },
    { key: "images", label: "Images", url: "/smartcharts/images", isButtonTab: true, icon: ImageIcon, class: "btn-img-btn" }
];
export const SMART_CHART_REPORT_VIEW = [
    { key: "reporttemplates", label: "Report Templates", url: "/smartcharts/reporttemplates" },
    { key: "corereports", label: "Core Reports", url: "/smartcharts/corereports", permissionKey: "core_report" },
    { key: "taskmanager", label: "Task Manager", url: "/smartcharts/taskmanager", role: "admin" }
];

export const SMART_CHART_FAVORITE_TAB_VIEWS = [
    { key: "reporttemplates", label: "Report Templates", url: "/smartcharts/reporttemplates" },
    { key: "reports", label: "Reports", url: "/smartcharts/reports" },
    { key: "corereports", label: "Core Reports", url: "/smartcharts/corereports", permissionKey: "core_report" },
    { key: "taskmanager", label: "Task Manager", url: "/smartcharts/taskmanager", role: "admin" }
];

export const DOC_AND_IMAGE_BANDS = [
    { key: "documents", label: "User Documents", dragDropKey: "USERDOCS" }
    // { key: "images", label: "Images", dragDropKey: "USERIMAGES" }
];

export const INDV_BUILDING_EXPORT_ENTITIES = [
    "buildings",
    "categories",
    "capital_type",
    "criticality",
    "priorities",
    "additions",
    "funding_sources",
    "trades",
    "system",
    "EFCI",
    "sorted_recom"
];

export const CA_RECOMMENDATION_ELEMENTS = [
    {
        key: "asset",
        label: "Asset",
        paramKey: "",
        columnOnly: true,
        hasFilter: false,
        hasColumnSelect: true
    },
    {
        key: "asstcondition",
        label: "Asset Condition",
        columnOnly: true,
        paramKey: "asset_condition_ids",
        hasFilter: true
    },
    {
        key: "capital",
        label: "Capital Type",
        paramKey: "capital_ids",
        hasFilter: true
    },
    {
        key: "category",
        label: "Category",
        paramKey: "category_ids",
        hasFilter: true
    },
    {
        key: "criticality",
        label: "Criticality",
        paramKey: "criticality_ids",
        hasFilter: true
    },
    {
        key: "fciefci",
        label: "FCI & EFCI",
        paramKey: null,
        hasFilter: false
    },
    {
        key: "fci_benchmarking",
        label: "FCI Benchmarking",
        paramKey: null,
        hasFilter: false
    },
    {
        key: "fundingsrc",
        label: "Funding Source",
        paramKey: "fundingsrc_ids",
        hasFilter: true
    },
    {
        key: "recommendations",
        label: "Recommendation",
        paramKey: "",
        columnOnly: true,
        haasFilter: false,
        hasColumnSelect: true
    },
    {
        key: "recomcondition",
        label: "Recommendation Condition",
        columnOnly: true,
        paramKey: "condition_ids",
        hasFilter: true
    },
    {
        key: "responsibility",
        label: "Responsibility",
        columnOnly: true,
        paramKey: "responsibility_ids",
        hasFilter: true
    },
    {
        key: "subsystem",
        label: "Sub-System",
        paramKey: "subsystem_ids",
        breakdowns: [
            { label: "Trade", key: "trade" },
            { label: "System", key: "system" }
        ],
        hasFilter: true,
        parentFilters: ["trade", "system"]
    },
    {
        key: "system",
        label: "System",
        paramKey: "system_ids",
        breakdowns: [{ label: "Trade", key: "trade" }],
        hasFilter: true,
        parentFilters: ["trade"]
    },
    {
        key: "term",
        label: "Term",
        paramKey: "term_ids",
        hasFilter: true
    },
    {
        key: "trade",
        label: "Trade",
        paramKey: "trade_ids",
        hasFilter: true
    }
];

export const CA_GEO_HIERARCHY_ELEMENTS = [
    { key: "project", label: "Project" },
    { key: "region", label: "Region" },
    {
        key: "site",
        label: "Site",
        breakdowns: [{ label: "Region", key: "region" }]
    },
    {
        key: "building",
        label: "Building",
        breakdowns: [
            { label: "Region", key: "region" },
            { label: "Site", key: "site" }
        ]
    },
    {
        key: "addition",
        label: "Addition",
        breakdowns: [
            { label: "Region", key: "region" },
            { label: "Site", key: "site" },
            { label: "Building", key: "building" }
        ]
    },
    {
        key: "recomtype",
        label: "Recommendation Criticality Type",
        columnOnly: true
    }
];

export const RECOMMENDATION_CRITICALITY_TYPES = {
    recomtype: [
        {
            id: "25c723e7-288d-4ed2-a456-3625e796a92d",
            name: "Immediate"
        },
        {
            id: "b044c1fe-bdf4-4caf-bc33-c1d40507ff18",
            name: "Reserve"
        }
    ]
};

export const IMAGE_BAND_CONFIG_TYPES = [
    { key: 1, label: "Single Image Band", icon: "/img/squre-img.png" },
    { key: 2, label: "Single Image Band", icon: "/img/rect-img.png" },
    { key: 3, label: "Double Image Band", icon: "/img/doub-img.png" },
    { key: 4, label: "Three Image Band", icon: "/img/three-image.svg" }
];

export const DOCUMENT_SORT_KEYS = {
    documents: [
        { label: "Created At", key: "created_at" },
        { label: "Name", key: "name" },
        { label: "File Name", key: "file_name" }
    ],
    images: [
        { label: "Created At", key: "created_at" },
        { label: "Caption", key: "caption" },
        { label: "File Name", key: "file_name" }
    ],
    reports: [
        { label: "Exported At", key: "created_date" },
        { label: "Exported By", key: "exported_by" },
        { label: "Name", key: "name" },
        { label: "Favorite", key: "favourite" }
    ],
    reporttemplates: [
        { label: "Created At", key: "created_date" },
        { label: "Modified At", key: "modified_date" },
        { label: "Locked", key: "is_locked" },
        { label: "Name", key: "name" },
        { label: "Created By", key: "created_by" }
    ],
    corereports: [
        { label: "Created At", key: "created_date" },
        { label: "Modified At", key: "modified_date" },
        { label: "Name", key: "name" },
        { label: "Created By", key: "created_by" }
    ],
    queries: [
        { label: "Created At", key: "created_date" },
        { label: "Name", key: "name" },
        { label: "Created By", key: "created_by" }
    ]
};

export const ADVANCED_FILTER_KEYS = {
    queries: {
        label: "Favorites",
        options: [
            { label: "All", key: "" },
            { label: "Favorites", key: "yes" },
            { label: "Non Favorites", key: "no" }
        ]
    },
    documents: {
        label: "Document Type",
        options: [
            { label: "All", key: "ALL" },
            { label: "Global User Documents", key: "GLB" },
            { label: "Client User Documents", key: "CLIENT" }
        ]
    },
    reports: {
        label: "Report Display",
        options: [
            { label: "All", key: "" },
            { label: "Favorites", key: "yes" },
            { label: "Non Favorites", key: "no" }
        ]
    },
    reporttemplates: {
        label: "Lock Status",
        options: [
            { label: "All", key: "" },
            { label: "Locked", key: true },
            { label: "Unlocked", key: false }
        ]
    }
};
export const DASHBOARD_CA_RECOMMENDATION_ELEMENTS = [
    {
        key: "trade",
        label: "trades",
        paramKey: "trade_ids"
    },
    {
        key: "region",
        label: "regions",
        paramKey: "region_ids"
    },
    {
        key: "category",
        label: "categories",
        paramKey: "category_ids",
        hasFilter: true
    },
    {
        key: "fundingsrc",
        label: "funding_sources",
        paramKey: "fundingsrc_ids",
        hasFilter: true
    },
    {
        key: "criticality",
        label: "criticality",
        paramKey: "criticality_ids",
        hasFilter: true
    },
    {
        key: "capital",
        label: "capital_type",
        paramKey: "capital_ids",
        hasFilter: true
    },
    {
        key: "term",
        label: "priorities",
        paramKey: "term_ids",
        hasFilter: true
    },
    {
        key: "responsibilities",
        label: "responsibilities",
        paramKey: "",
        columnOnly: true,
        haasFilter: false,
        hasColumnSelect: true
    },
    {
        key: "project",
        label: "projects"
    },
    {
        key: "site",
        label: "sites"
    },
    {
        key: "building",
        label: "buildings"
    }
];
export const DASHBOARD_CATEGORYCHART = [
    {
        key: "trade",
        label: "trades"
    },
    {
        key: "regions",
        label: "regions"
    },
    {
        key: "categories",
        label: "categories"
    },
    {
        key: "funding_sources",
        label: "funding_sources"
    },
    {
        key: "criticality",
        label: "criticality"
    },
    {
        key: "capital_type",
        label: "capital_type"
    },
    {
        key: "term",
        label: "priorities"
    },
    {
        key: "responsibilities",
        label: "responsibilities"
    },
    {
        key: "projects",
        label: "projects"
    },
    {
        key: "sites",
        label: "sites"
    },
    {
        key: "buildings",
        label: "buildings"
    }
];

export const GET_MASTER_FILTER_IN_SMART_CHART_REQUEST = "GET_MASTER_FILTER_IN_SMART_CHART_REQUEST";
export const GET_MASTER_FILTER_IN_SMART_CHART_SUCCESS = "GET_MASTER_FILTER_IN_SMART_CHART_SUCCESS";
export const GET_MASTER_FILTER_IN_SMART_CHART_FAILURE = "GET_MASTER_FILTER_IN_SMART_CHART_FAILURE";

export const EXPORT_SMART_CHART_DATA_REQUEST = "EXPORT_SMART_CHART_DATA_REQUEST";
export const EXPORT_SMART_CHART_DATA_SUCCESS = "EXPORT_SMART_CHART_DATA_SUCCESS";
export const EXPORT_SMART_CHART_DATA_FAILURE = "EXPORT_SMART_CHART_DATA_FAILURE";

export const SAVE_SMART_CHART_DATA_REQUEST = "SAVE_SMART_CHART_DATA_REQUEST";
export const SAVE_SMART_CHART_DATA_SUCCESS = "SAVE_SMART_CHART_DATA_SUCCESS";
export const SAVE_SMART_CHART_DATA_FAILURE = "SAVE_SMART_CHART_DATA_FAILURE";

export const GET_EXPORTED_SMART_CHART_LIST_REQUEST = "GET_EXPORTED_SMART_CHART_LIST_REQUEST";
export const GET_EXPORTED_SMART_CHART_LIST_SUCCESS = "GET_EXPORTED_SMART_CHART_LIST_SUCCESS";
export const GET_EXPORTED_SMART_CHART_LIST_FAILURE = "GET_EXPORTED_SMART_CHART_LIST_FAILURE";

export const DELETE_SMART_CHART_REPORT_REQUEST = "DELETE_SMART_CHART_REPORT_REQUEST";
export const DELETE_SMART_CHART_REPORT_SUCCESS = "DELETE_SMART_CHART_REPORT_SUCCESS";
export const DELETE_SMART_CHART_REPORT_FAILURE = "DELETE_SMART_CHART_REPORT_FAILURE";

export const UPLOAD_DOC_FOR_SMART_REPORT_REQUEST = "UPLOAD_DOC_FOR_SMART_REPORT_REQUEST";
export const UPLOAD_DOC_FOR_SMART_REPORT_SUCCESS = "UPLOAD_DOC_FOR_SMART_REPORT_SUCCESS";
export const UPLOAD_DOC_FOR_SMART_REPORT_FAILURE = "UPLOAD_DOC_FOR_SMART_REPORT_FAILURE";

export const GET_UPLOADED_DOC_LIST_REQUEST = "GET_UPLOADED_DOC_LIST_REQUEST";
export const GET_UPLOADED_DOC_LIST_SUCCESS = "GET_UPLOADED_DOC_LIST_SUCCESS";
export const GET_UPLOADED_DOC_LIST_FAILURE = "GET_UPLOADED_DOC_LIST_FAILURE";

export const UPDATE_SMART_REPORT_DATA_REQUEST = "UPDATE_SMART_REPORT_DATA_REQUEST";
export const UPDATE_SMART_REPORT_DATA_SUCCESS = "UPDATE_SMART_REPORT_DATA_SUCCESS";
export const UPDATE_SMART_REPORT_DATA_FAILURE = "UPDATE_SMART_REPORT_DATA_FAILURE";

export const GET_TEMPLATE_PROPERTIES_LIST_REQUEST = "GET_TEMPLATE_PROPERTIES_LIST_REQUEST";
export const GET_TEMPLATE_PROPERTIES_LIST_SUCCESS = "GET_TEMPLATE_PROPERTIES_LIST_SUCCESS";
export const GET_TEMPLATE_PROPERTIES_LIST_FAILURE = "GET_TEMPLATE_PROPERTIES_LIST_FAILURE";

export const GET_TEMPLATE_LIST_REQUEST = "GET_TEMPLATE_LIST_REQUEST";
export const GET_TEMPLATE_LIST_SUCCESS = "GET_TEMPLATE_LIST_SUCCESS";
export const GET_TEMPLATE_LIST_FAILURE = "GET_TEMPLATE_LIST_FAILURE";

export const DELETE_USER_DOC_REQUEST = "DELETE_USER_DOC_REQUEST";
export const DELETE_USER_DOC_SUCCESS = "DELETE_USER_DOC_SUCCESS";
export const DELETE_USER_DOC_FAILURE = "DELETE_USER_DOC_FAILURE";

export const GET_CLIENTS_LIST_FOR_SMART_CHART_REQUEST = "GET_CLIENTS_LIST_FOR_SMART_CHART_REQUEST";
export const GET_CLIENTS_LIST_FOR_SMART_CHART_SUCCESS = "GET_CLIENTS_LIST_FOR_SMART_CHART_SUCCESS";
export const GET_CLIENTS_LIST_FOR_SMART_CHART_FAILURE = "GET_CLIENTS_LIST_FOR_SMART_CHART_FAILURE";

export const UPDATE_DOC_ORDER_REQUEST = "UPDATE_DOC_ORDER_REQUEST";
export const UPDATE_DOC_ORDER_SUCCESS = "UPDATE_DOC_ORDER_SUCCESS";
export const UPDATE_DOC_ORDER_FAILURE = "UPDATE_DOC_ORDER_FAILURE";

export const UPDATE_USER_DOC_DATA_REQUEST = "UPDATE_USER_DOC_DATA_REQUEST";
export const UPDATE_USER_DOC_DATA_SUCCESS = "UPDATE_USER_DOC_DATA_SUCCESS";
export const UPDATE_USER_DOC_DATA_FAILURE = "UPDATE_USER_DOC_DATA_FAILURE";

export const UPDATE_SMART_CHART_PROPERTY_REQUEST = "UPDATE_SMART_CHART_PROPERTY_REQUEST";
export const UPDATE_SMART_CHART_PROPERTY_SUCCESS = "UPDATE_SMART_CHART_PROPERTY_SUCCESS";
export const UPDATE_SMART_CHART_PROPERTY_FAILURE = "UPDATE_SMART_CHART_PROPERTY_FAILURE";

export const GET_SMART_CHART_PROPERTIES_LIST_REQUEST = "GET_SMART_CHART_PROPERTIES_LIST_REQUEST";
export const GET_SMART_CHART_PROPERTIES_LIST_SUCCESS = "GET_SMART_CHART_PROPERTIES_LIST_SUCCESS";
export const GET_SMART_CHART_PROPERTIES_LIST_FAILURE = "GET_SMART_CHART_PROPERTIES_LIST_FAILURE";

export const GET_PREVIEW_DOC_REQUEST = "GET_PREVIEW_DOC_REQUEST";
export const GET_PREVIEW_DOC_SUCCESS = "GET_PREVIEW_DOC_SUCCESS";
export const GET_PREVIEW_DOC_FAILURE = "GET_PREVIEW_DOC_FAILURE";

export const GET_SMART_CHART_PROPERTIES_SOURCETEMPLETE_REQUEST = "GET_SMART_CHART_PROPERTIES_SOURCETEMPLETE_REQUEST";
export const GET_SMART_CHART_PROPERTIES_SOURCETEMPLETE_SUCCESS = "GET_SMART_CHART_PROPERTIES_SOURCETEMPLETE_SUCCESS";
export const GET_SMART_CHART_PROPERTIES_SOURCETEMPLETE_FAILURE = "GET_SMART_CHART_PROPERTIES_SOURCETEMPLETE_FAILURE";

export const GET_SMART_CHART_PROPERTY_BY_ID_REQUEST = "GET_SMART_CHART_PROPERTY_BY_ID_REQUEST";
export const GET_SMART_CHART_PROPERTY_BY_ID_SUCCESS = "GET_SMART_CHART_PROPERTY_BY_ID_SUCCESS";
export const GET_SMART_CHART_PROPERTY_BY_ID_FAILURE = "GET_SMART_CHART_PROPERTY_BY_ID_FAILURE";

export const UPDATE_SMART_REPORT_ENTITY_PARAMS_SUCCESS = "UPDATE_SMART_REPORT_ENTITY_PARAMS_SUCCESS";
export const UPDATE_SMART_REPORT_ENTITY_PARAMS_FAILURE = "UPDATE_SMART_REPORT_ENTITY_PARAMS_FAILURE";

export const GET_UPLOADED_IMAGE_LIST_REQUEST = "GET_UPLOADED_IMAGE_LIST_REQUEST";
export const GET_UPLOADED_IMAGE_LIST_SUCCESS = "GET_UPLOADED_IMAGE_LIST_SUCCESS";
export const GET_UPLOADED_IMAGE_LIST_FAILURE = "GET_UPLOADED_IMAGE_LIST_FAILURE";

export const DELETE_TASK_MANAGER_BY_ID_FAILURE = "DELETE_TASK_MANAGER_BY_ID_FAILURE";
export const DELETE_TASK_MANAGER_BY_ID_SUCCESS = "DELETE_TASK_MANAGER_BY_ID_SUCCESS";
export const DELETE_TASK_MANAGER_BY_ID_REQUEST = "DELETE_TASK_MANAGER_BY_ID_REQUEST";

export const GET_TASK_MANAGER_TABLE_FILTER_FAILURE = "GET_TASK_MANAGER_TABLE_FILTER_FAILURE";
export const GET_TASK_MANAGER_TABLE_FILTER_REQUEST = "GET_TASK_MANAGER_TABLE_FILTER_REQUEST";
export const GET_TASK_MANAGER_TABLE_FILTER_SUCCESS = "GET_TASK_MANAGER_TABLE_FILTER_SUCCESS";

export const UPDATE_END_TASK_FAILURE = "UPDATE_END_TASK_FAILURE";
export const UPDATE_END_TASK_SUCCESS = "UPDATE_END_TASK_SUCCESS";
export const UPDATE_END_TASK_REQUEST = "UPDATE_END_TASK_REQUEST";

export const SAVE_AND_EXPORT_SMART_CHART_DATA_REQUEST = "SAVE_AND_EXPORT_SMART_CHART_DATA_REQUEST";
export const SAVE_AND_EXPORT_SMART_CHART_DATA_SUCCESS = "SAVE_AND_EXPORT_SMART_CHART_DATA_SUCCESS";
export const SAVE_AND_EXPORT_SMART_CHART_DATA_FAILURE = "SAVE_AND_EXPORT_SMART_CHART_DATA_FAILURE";

export const SET_LAST_VISITED_REPORT = "SET_LAST_VISITED_REPORT";

export const DELETE_SMART_CHART_REPORT_TEMPLATE_REQUEST = "DELETE_SMART_CHART_REPORT_TEMPLATE_REQUEST";
export const DELETE_SMART_CHART_REPORT_TEMPLATE_SUCCESS = "DELETE_SMART_CHART_REPORT_TEMPLATE_SUCCESS";
export const DELETE_SMART_CHART_REPORT_TEMPLATE_FAILURE = "DELETE_SMART_CHART_REPORT_TEMPLATE_FAILURE";

export const GET_REPORTS_BY_TEMPLATE_LIST_REQUEST = "GET_REPORTS_BY_TEMPLATE_LIST_REQUEST";
export const GET_REPORTS_BY_TEMPLATE_LIST_SUCCESS = "GET_REPORTS_BY_TEMPLATE_LIST_SUCCESS";
export const GET_REPORTS_BY_TEMPLATE_LIST_FAILURE = "GET_REPORTS_BY_TEMPLATE_LIST_FAILURE";

export const ASSIGN_IMAGES_TO_SMART_CHARTS_REQUEST = "ASSIGN_IMAGES_TO_SMART_CHARTS_REQUEST";
export const ASSIGN_IMAGES_TO_SMART_CHARTS_SUCCESS = "ASSIGN_IMAGES_TO_SMART_CHARTS_SUCCESS";
export const ASSIGN_IMAGES_TO_SMART_CHARTS_FAILURE = "ASSIGN_IMAGES_TO_SMART_CHARTS_FAILURE";

export const LOCK_SMART_CHART_TEMPLATE_REQUEST = "LOCK_SMART_CHART_TEMPLATE_REQUEST";
export const LOCK_SMART_CHART_TEMPLATE_SUCCESS = "LOCK_SMART_CHART_TEMPLATE_SUCCESS";
export const LOCK_SMART_CHART_TEMPLATE_FAILURE = "LOCK_SMART_CHART_TEMPLATE_FAILURE";

export const GET_CA_BAND_FILTER_DROPDOWN_DATA_REQUEST = "GET_CA_BAND_FILTER_DROPDOWN_DATA_REQUEST";
export const GET_CA_BAND_FILTER_DROPDOWN_DATA_SUCCESS = "GET_CA_BAND_FILTER_DROPDOWN_DATA_SUCCESS";
export const GET_CA_BAND_FILTER_DROPDOWN_DATA_FAILURE = "GET_CA_BAND_FILTER_DROPDOWN_DATA_FAILURE";

export const GET_TASK_MANAGER_LIST_REQUEST = "GET_TASK_MANAGER_LIST_REQUEST";
export const GET_TASK_MANAGER_LIST_SUCCESS = "GET_TASK_MANAGER_LIST_SUCCESS";
export const GET_TASK_MANAGER_LIST_FAILURE = "GET_TASK_MANAGER_LIST_FAILURE";

export const ADD_SMART_CHART_TO_FAVORITES_REQUEST = "ADD_SMART_CHART_TO_FAVORITES_REQUEST";
export const ADD_SMART_CHART_TO_FAVORITES_SUCCESS = "ADD_SMART_CHART_TO_FAVORITES_SUCCESS";
export const ADD_SMART_CHART_TO_FAVORITES_FAILURE = "ADD_SMART_CHART_TO_FAVORITES_FAILURE";

export const UPDATE_ENTITY_FILTER_PARAMS_SMART_CHARTS = "UPDATE_ENTITY_FILTER_PARAMS_SMART_CHARTS";

export const CLEAR_SMART_CHART_REDUCER_DATA = "CLEAR_SMART_CHART_REDUCER_DATA";

export const GET_CA_BAND_TRADE_FILTER_DROPDOWN_DATA_REQUEST = "GET_CA_BAND_TRADE_FILTER_DROPDOWN_DATA_REQUEST";
export const GET_CA_BAND_TRADE_FILTER_DROPDOWN_DATA_SUCCESS = "GET_CA_BAND_TRADE_FILTER_DROPDOWN_DATA_SUCCESS";
export const GET_CA_BAND_TRADE_FILTER_DROPDOWN_DATA_FAILURE = "GET_CA_BAND_TRADE_FILTER_DROPDOWN_DATA_FAILURE";

export const UPDATE_SMART_REPORT_TEMPLATE_ENTITY_PARAMS_SUCCESS = "UPDATE_SMART_REPORT_TEMPLATE_ENTITY_PARAMS_SUCCESS";
export const UPDATE_SMART_REPORT_TEMPLATE_ENTITY_PARAMS_FAILURE = "UPDATE_SMART_REPORT_TEMPLATE_ENTITY_PARAMS_FAILURE";

export const RESET_SMART_REPORT_TEMPLATE_ENTITY_PARAMS = "RESET_SMART_REPORT_TEMPLATE_ENTITY_PARAMS";

export const GET_USERS_BY_CLIENT_REQUEST = "GET_USERS_BY_CLIENT_REQUEST";
export const GET_USERS_BY_CLIENT_SUCCESS = "GET_USERS_BY_CLIENT_SUCCESS";
export const GET_USERS_BY_CLIENT_FAILURE = "GET_USERS_BY_CLIENT_FAILURE";

export const ASSIGN_FAVORITE_TO_USERS_REQUEST = "ASSIGN_FAVORITE_TO_USERS_REQUEST";
export const ASSIGN_FAVORITE_TO_USERS_SUCCESS = "ASSIGN_FAVORITE_TO_USERS_SUCCESS";
export const ASSIGN_FAVORITE_TO_USERS_FAILURE = "ASSIGN_FAVORITE_TO_USERS_FAILURE";

export const CLEAR_USER_BY_CLIENT_DATA = "CLEAR_USER_BY_CLIENT_DATA";

export const GET_EXPORT_PROPERTY_LIST_NORMAL_RECOM_REQUEST = "GET_EXPORT_PROPERTY_LIST_NORMAL_RECOM_REQUEST";
export const GET_EXPORT_PROPERTY_LIST_NORMAL_RECOM_SUCCESS = "GET_EXPORT_PROPERTY_LIST_NORMAL_RECOM_SUCCESS";
export const GET_EXPORT_PROPERTY_LIST_NORMAL_RECOM_FAILURE = "GET_EXPORT_PROPERTY_LIST_NORMAL_RECOM_FAILURE";

export const GET_EXPORT_TEMPLATE_LIST_NORMAL_RECOM_REQUEST = "GET_EXPORT_TEMPLATE_LIST_NORMAL_RECOM_REQUEST";
export const GET_EXPORT_TEMPLATE_LIST_NORMAL_RECOM_SUCCESS = "GET_EXPORT_TEMPLATE_LIST_NORMAL_RECOM_SUCCESS";
export const GET_EXPORT_TEMPLATE_LIST_NORMAL_RECOM_FAILURE = "GET_EXPORT_TEMPLATE_LIST_NORMAL_RECOM_FAILURE";

export const GET_EXPORT_SETTINGS_NORMAL_RECOM_REQUEST = "GET_EXPORT_SETTINGS_NORMAL_RECOM_REQUEST";
export const GET_EXPORT_SETTINGS_NORMAL_RECOM_SUCCESS = "GET_EXPORT_SETTINGS_NORMAL_RECOM_SUCCESS";
export const GET_EXPORT_SETTINGS_NORMAL_RECOM_FAILURE = "GET_EXPORT_SETTINGS_NORMAL_RECOM_FAILURE";

export const ADD_EXPORT_SETTINGS_NORMAL_RECOM_REQUEST = "ADD_EXPORT_SETTINGS_NORMAL_RECOM_REQUEST";
export const ADD_EXPORT_SETTINGS_NORMAL_RECOM_SUCCESS = "ADD_EXPORT_SETTINGS_NORMAL_RECOM_SUCCESS";
export const ADD_EXPORT_SETTINGS_NORMAL_RECOM_FAILURE = "ADD_EXPORT_SETTINGS_NORMAL_RECOM_FAILURE";

export const CLEAR_PROPERTY_BY_ID_DATA = "CLEAR_PROPERTY_BY_ID_DATA";

export const GET_CA_BAND_SYSTEM_FILTER_DROPDOWN_DATA_REQUEST = "GET_CA_BAND_SYSTEM_FILTER_DROPDOWN_DATA_REQUEST";
export const GET_CA_BAND_SYSTEM_FILTER_DROPDOWN_DATA_SUCCESS = "GET_CA_BAND_SYSTEM_FILTER_DROPDOWN_DATA_SUCCESS";
export const GET_CA_BAND_SYSTEM_FILTER_DROPDOWN_DATA_FAILURE = "GET_CA_BAND_SYSTEM_FILTER_DROPDOWN_DATA_FAILURE";

export const CREATE_SKELETON_FROM_TEMPLATE_REQUEST = "CREATE_SKELETON_FROM_TEMPLATE_REQUEST";
export const CREATE_SKELETON_FROM_TEMPLATE_SUCCESS = "CREATE_SKELETON_FROM_TEMPLATE_SUCCESS";
export const CREATE_SKELETON_FROM_TEMPLATE_FAILURE = "CREATE_SKELETON_FROM_TEMPLATE_FAILURE";

export const GET_EXPORT_SETTINGS_IDS_FOR_NORMAL_RECOM_REQUEST = "GET_EXPORT_SETTINGS_IDS_FOR_NORMAL_RECOM_REQUEST";
export const GET_EXPORT_SETTINGS_IDS_FOR_NORMAL_RECOM_SUCCESS = "GET_EXPORT_SETTINGS_IDS_FOR_NORMAL_RECOM_SUCCESS";
export const GET_EXPORT_SETTINGS_IDS_FOR_NORMAL_RECOM_FAILURE = "GET_EXPORT_SETTINGS_IDS_FOR_NORMAL_RECOM_FAILURE";
export const CLEAR_SETTINGS_IDS_FOR_NORMAL_RECOM = "CLEAR_SETTINGS_IDS_FOR_NORMAL_RECOM";

export const CREATE_REPORT_FROM_CORE_REPORT_REQUEST = "CREATE_REPORT_FROM_CORE_REPORT_REQUEST";
export const CREATE_REPORT_FROM_CORE_REPORT_SUCCESS = "CREATE_REPORT_FROM_CORE_REPORT_SUCCESS";
export const CREATE_REPORT_FROM_CORE_REPORT_FAILURE = "CREATE_REPORT_FROM_CORE_REPORT_FAILURE";

export const UPDATE_CORE_REPORT_DATA_REQUEST = "UPDATE_CORE_REPORT_DATA_REQUEST";
export const UPDATE_CORE_REPORT_DATA_SUCCESS = "UPDATE_CORE_REPORT_DATA_SUCCESS";
export const UPDATE_CORE_REPORT_DATA_FAILURE = "UPDATE_CORE_REPORT_DATA_FAILURE";

export const GET_CA_COLUMNS_REQUEST = "GET_CA_COLUMNS_REQUEST";
export const GET_CA_COLUMNS_SUCCESS = "GET_CA_COLUMNS_SUCCESS";
export const GET_CA_COLUMNS_FAILURE = "GET_CA_COLUMNS_FAILURE";

export const CLEAR_ALL_TASK_REQUEST = "CLEAR_ALL_TASK_REQUEST";
export const CLEAR_ALL_TASK_SUCCESS = "CLEAR_ALL_TASK_SUCCESS";
export const CLEAR_ALL_TASK_FAILURE = "CLEAR_ALL_TASK_FAILURE";

export const GET_EXPORT_SETTINGS_ASSET_REQUEST = "GET_EXPORT_SETTINGS_ASSET_REQUEST";
export const GET_EXPORT_SETTINGS_ASSET_SUCCESS = "GET_EXPORT_SETTINGS_ASSET_SUCCESS";
export const GET_EXPORT_SETTINGS_ASSET_FAILURE = "GET_EXPORT_SETTINGS_ASSET_FAILURE";

export const GET_EXPORT_PROPERTY_LIST_ASSET_REQUEST = "GET_EXPORT_PROPERTY_LIST_ASSET_REQUEST";
export const GET_EXPORT_PROPERTY_LIST_ASSET_SUCCESS = "GET_EXPORT_PROPERTY_LIST_ASSET_SUCCESS";
export const GET_EXPORT_PROPERTY_LIST_ASSET_FAILURE = "GET_EXPORT_PROPERTY_LIST_ASSET_FAILURE";

export const GET_EXPORT_TEMPLATE_LIST_ASSET_REQUEST = "GET_EXPORT_TEMPLATE_LIST_ASSET_REQUEST";
export const GET_EXPORT_TEMPLATE_LIST_ASSET_SUCCESS = "GET_EXPORT_TEMPLATE_LIST_ASSET_SUCCESS";
export const GET_EXPORT_TEMPLATE_LIST_ASSET_FAILURE = "GET_EXPORT_TEMPLATE_LIST_ASSET_FAILURE";

export const ADD_EXPORT_SETTINGS_ASSET_REQUEST = "ADD_EXPORT_SETTINGS_ASSET_REQUEST";
export const ADD_EXPORT_SETTINGS_ASSET_SUCCESS = "ADD_EXPORT_SETTINGS_ASSET_SUCCESS";
export const ADD_EXPORT_SETTINGS_ASSET_FAILURE = "ADD_EXPORT_SETTINGS_ASSET_FAILURE";

export const GET_SMART_CHART_LOG_REQUEST = "GET_SMART_CHART_LOG_REQUEST";
export const GET_SMART_CHART_LOG_SUCCESS = "GET_SMART_CHART_LOG_SUCCESS";
export const GET_SMART_CHART_LOG_FAILURE = "GET_SMART_CHART_LOG_FAILURE";

export const GET_BUILDING_TRADES_REQUEST = "GET_BUILDING_TRADES_REQUEST";
export const GET_BUILDING_TRADES_SUCCESS = "GET_BUILDING_TRADES_SUCCESS";
export const GET_BUILDING_TRADES_FAILURE = "GET_BUILDING_TRADES_FAILURE";

export const GET_ASPOSE_STATUS_REQUEST = "GET_ASPOSE_STATUS_REQUEST";
export const GET_ASPOSE_STATUS_SUCCESS = "GET_ASPOSE_STATUS_SUCCESS";
export const GET_ASPOSE_STATUS_FAILURE = "GET_ASPOSE_STATUS_FAILURE";

export const GET_DEFAULT_BREAKDOWN_PROPERTY_REQUEST = "GET_DEFAULT_BREAKDOWN_PROPERTY_REQUEST";
export const GET_DEFAULT_BREAKDOWN_PROPERTY_SUCCESS = "GET_DEFAULT_BREAKDOWN_PROPERTY_SUCCESS";
export const GET_DEFAULT_BREAKDOWN_PROPERTY_FAILURE = "GET_DEFAULT_BREAKDOWN_PROPERTY_FAILURE";

export const PATCH_BREAKDOWN_PROPERTY_REQUEST = "PATCH_BREAKDOWN_PROPERTY_REQUEST";
export const PATCH_BREAKDOWN_PROPERTY_SUCCESS = "PATCH_BREAKDOWN_PROPERTY_SUCCESS";
export const PATCH_BREAKDOWN_PROPERTY_FAILURE = "PATCH_BREAKDOWN_PROPERTY_FAILURE";

export const GET_DEFAULT_BBI_PROPERTY_REQUEST = "GET_DEFAULT_BBI_PROPERTY_REQUEST";
export const GET_DEFAULT_BBI_PROPERTY_SUCCESS = "GET_DEFAULT_BBI_PROPERTY_SUCCESS";
export const GET_DEFAULT_BBI_PROPERTY_FAILURE = "GET_DEFAULT_BBI_PROPERTY_FAILURE";

export const GET_DEFAULT_BSI_PROPERTY_REQUEST = "GET_DEFAULT_BSI_PROPERTY_REQUEST";
export const GET_DEFAULT_BSI_PROPERTY_SUCCESS = "GET_DEFAULT_BSI_PROPERTY_SUCCESS";
export const GET_DEFAULT_BSI_PROPERTY_FAILURE = "GET_DEFAULT_BSI_PROPERTY_FAILURE";

export const GET_HEADER_KEY_LIST_REQUEST = "GET_HEADER_KEY_LIST_REQUEST";
export const GET_HEADER_KEY_LIST_SUCCESS = "GET_HEADER_KEY_LIST_SUCCESS";
export const GET_HEADER_KEY_LIST_FAILURE = "GET_HEADER_KEY_LIST_FAILURE";

export const GET_EXECUTIVE_SUMMARY_BAND_TILES_REQUEST = "GET_EXECUTIVE_SUMMARY_BAND_TILES_REQUEST";
export const GET_EXECUTIVE_SUMMARY_BAND_TILES_SUCCESS = "GET_EXECUTIVE_SUMMARY_BAND_TILES_SUCCESS";
export const GET_EXECUTIVE_SUMMARY_BAND_TILES_FAILURE = "GET_EXECUTIVE_SUMMARY_BAND_TILES_FAILURE";

export const SAVE_EXECUTIVE_SUMMARY_TILE_TO_BUILDING_REQUEST = "SAVE_EXECUTIVE_SUMMARY_TILE_TO_BUILDING_REQUEST";
export const SAVE_EXECUTIVE_SUMMARY_TILE_TO_BUILDING_SUCCESS = "SAVE_EXECUTIVE_SUMMARY_TILE_TO_BUILDING_SUCCESS";
export const SAVE_EXECUTIVE_SUMMARY_TILE_TO_BUILDING_FAILURE = "SAVE_EXECUTIVE_SUMMARY_TILE_TO_BUILDING_FAILURE";

export const RESET_BUILDING_TRADE_DATA = "RESET_BUILDING_TRADE_DATA";

export const DEFAULT_PROPERTY_VALUE = {
    project: {
        band1: {
            mfilter: {},
            type: {
                regions: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                sites: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                buildings: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                building_type: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                additions: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                sorted_recom: {
                    band1: {
                        is_soft_cost: false,
                        mfilter: {},
                        type: ["building"],
                        name: "Sorted Recommendation"
                    }
                },
                filter_report1: {
                    hasConfig: false,
                    isVisible: true,
                    name: "Master Filters",
                    band1: {
                        mfilter: {}
                    }
                },
                criticality: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                condition: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                categories: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                funding_sources: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                priorities: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                trades: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                system: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    normal_recom: { band1: { mfilter: {}, remove_section_break: false, name: "Recommendations", config_filter: {} } },
                    remove_tbl_section_break: false,
                    combination: false
                },
                subsystem: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                responsibilities: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                capital_type: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                EFCI: {
                    detailed_view: {
                        chart_type: ["line_column_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            width: null,
                            height: null,
                            autoCalculate: true,
                            funding_source: [1, 2, 3, 4],
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                energy_band: { remove_section_break: false },
                water_band: "",
                asset_band: {
                    table_view: ""
                },
                building_report1: {
                    band1: { mfilter: {}, name: "BBI/Stoplight Chart", remove_section_break: false }
                },
                addition_report1: {
                    band1: { mfilter: {}, bai_report: true, stop_light_report: false, name: "BAI" }
                },
                site_report1: {
                    band1: { mfilter: {}, bsi_report: true, stop_light_report: false, name: "BSI/Stoplight Chart" }
                },
                recommendation_status: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                building_addition_sf: {
                    table_view: "",
                    summary_view: {
                        chart_type: ["donut_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                },
                table_of_contents: {
                    name: "TABLE OF CONTENTS",
                    remove_section_break: false,
                    custom_heading_props: {
                        bold: true,
                        color: "003f2d",
                        font_size: 20,
                        font_id: "",
                        bg_color: "ffffff",
                        alignment: "center",
                        cell_margin: {
                            top: 0.04,
                            left: 0.04,
                            right: 0.04,
                            bottom: 0.04
                        }
                    },
                    structured_heading: {}
                },
                project_cost: {
                    table_view: "",
                    show_columns: {
                        setting: true,
                        actual: true,
                        Setting: {
                            percentage: true,
                            value: true
                        },
                        Actual: {
                            percentage: true,
                            value: true
                        }
                    },
                    summary_view: {
                        chart_type: ["pie_3d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        remove_section_break: false,
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    },
                    remove_tbl_section_break: false
                }
            }
        }
    },
    assets: {
        band1: {
            mfilter: {},
            type: {
                asset_band: {
                    table_view: ""
                },
                end_servicelife_year_condition: {
                    table_view: "",
                    detailed_view: { chart_type: ["stacked_column_2d", "stacked_column_3d"] }
                },
                asset_age_by_condition: {
                    table_view: "",
                    detailed_view: { chart_type: ["stacked_column_2d", "stacked_column_3d"] }
                },
                asset_capital_spending_plan: {
                    table_view: "",
                    summary_view: { chart_type: ["pie_2d", "pie_3d"] },
                    detailed_view: { chart_type: ["stacked_column_2d", "stacked_column_3d"] }
                },
                asset_system_facility: {
                    table_view: "",
                    detailed_view: { chart_type: ["stacked_column_2d", "stacked_column_3d"] }
                }
            }
        }
    },
    energy_mng: {
        band1: {
            mfilter: {},
            type: {
                em_eui_building_breakdown: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                em_eci_building_breakdown: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                bld_brkdown_energy_usage: { summary_view: { chart_type: ["pie_2d"], config: { sort_by: { name: "asc" } } } },
                em_eui_site_brkdown_energy_use: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                em_eui_energy_usage: {
                    summary_view: {
                        chart_type: ["pie_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                bld_brkdown_energy_cost: {
                    summary_view: {
                        chart_type: ["pie_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                em_eci_site_cost: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                em_eci_energy_cost: {
                    summary_view: {
                        chart_type: ["pie_2d", "pie_3d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                monthly_electricity_cost: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                monthly_gas_cost: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                monthly_total_energy_cost: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                monthly_electricity_usage: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                monthly_gas_usage: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                monthly_total_energy_usage: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"],
                        config: {
                            legend: true,
                            color_legend: true,
                            header: true,
                            total: true,
                            sort_by: { name: "asc" }
                        }
                    }
                },
                energy_band: { remove_section_break: false },
                water_band: ""
            }
        }
    }
};

export const DEFAULT_PROPERTY_VALUE_FOR_EXCEL = {
    project: {
        band1: {
            mfilter: {},
            type: {
                regions: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                sites: { table_view: "", remove_tbl_section_break: false },
                buildings: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                building_type: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                additions: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                sorted_recom: {
                    band1: {
                        is_soft_cost: false,
                        mfilter: {},
                        type: ["building"],
                        name: "Sorted Recommendation"
                    }
                },
                filter_report1: {
                    hasConfig: false,
                    isVisible: true,
                    name: "Master Filters",
                    band1: {
                        mfilter: {}
                    }
                },
                condition: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                criticality: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                categories: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                funding_sources: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                priorities: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                trades: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                // system: {
                //     table_view: ""
                // },
                // subsystem: {
                //     table_view: ""
                // },
                responsibilities: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                capital_type: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                // EFCI: {
                //     detailed_view: {
                //         chart_type: ["line_column_2d"]
                //     }
                // },
                energy_band: { remove_section_break: false },
                water_band: "",
                asset_band: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                recommendation_status: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                building_addition_sf: {
                    table_view: "",
                    remove_tbl_section_break: false
                },
                table_of_contents: {
                    name: "TABLE OF CONTENTS",
                    remove_section_break: false,
                    custom_heading_props: {
                        bold: true,
                        color: "003f2d",
                        font_size: 20,
                        font_id: "27657a23-5649-4958-b5c4-f3f4774503f2",
                        bg_color: "ffffff",
                        alignment: "center",
                        cell_margin: {
                            top: 0.04,
                            left: 0.04,
                            right: 0.04,
                            bottom: 0.04
                        }
                    },
                    structured_heading: {}
                },
                project_cost: {
                    table_view: "",
                    show_columns: {
                        setting: true,
                        actual: true,
                        Setting: {
                            percentage: true,
                            value: true
                        },
                        Actual: {
                            percentage: true,
                            value: true
                        }
                    },
                    remove_tbl_section_break: false
                }
            }
        }
    },
    assets: {
        band1: {
            mfilter: {},
            type: {
                asset_band: {
                    table_view: ""
                },
                end_servicelife_year_condition: {
                    table_view: "",
                    detailed_view: { chart_type: ["stacked_column_2d", "stacked_column_3d"] }
                },
                asset_age_by_condition: {
                    table_view: "",
                    detailed_view: { chart_type: ["stacked_column_2d", "stacked_column_3d"] }
                },
                asset_capital_spending_plan: {
                    table_view: "",
                    summary_view: { chart_type: ["pie_2d", "pie_3d"] },
                    detailed_view: { chart_type: ["stacked_column_2d", "stacked_column_3d"] }
                },
                asset_system_facility: {
                    table_view: "",
                    detailed_view: { chart_type: ["stacked_column_2d", "stacked_column_3d"] }
                }
            }
        }
    },
    energy_mng: {
        band1: {
            mfilter: {},
            type: {
                em_eui_building_breakdown: { detailed_view: { chart_type: ["stacked_column_2d"] } },
                em_eci_building_breakdown: { detailed_view: { chart_type: ["stacked_column_2d"] } },
                bld_brkdown_energy_usage: { summary_view: { chart_type: ["pie_2d"] } },
                em_eui_site_brkdown_energy_use: { detailed_view: { chart_type: ["stacked_column_2d"] } },
                em_eui_energy_usage: { summary_view: { chart_type: ["pie_2d"] } },
                bld_brkdown_energy_cost: { summary_view: { chart_type: ["pie_2d"] } },
                em_eci_site_cost: { detailed_view: { chart_type: ["stacked_column_2d"] } },
                em_eci_energy_cost: { summary_view: { chart_type: ["pie_2d", "pie_3d"] } },
                monthly_electricity_cost: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"]
                    }
                },
                monthly_gas_cost: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"]
                    }
                },
                monthly_total_energy_cost: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"]
                    }
                },
                monthly_electricity_usage: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"]
                    }
                },
                monthly_gas_usage: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"]
                    }
                },
                monthly_total_energy_usage: {
                    detailed_view: {
                        chart_type: ["stacked_column_2d"]
                    }
                },
                energy_band: { remove_section_break: false },
                water_band: ""
            }
        }
    }
};

export const CHART_ITEMS_FOR_EXCEL = {
    project: {
        regions: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: { table_view: "", remove_tbl_section_break: false }
        },
        sites: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: { table_view: "", remove_tbl_section_break: false }
        },
        buildings: {
            config: {
                table_view: true
            },
            hasConfig: true,
            isVisible: true,
            defaultValue: { table_view: "", remove_tbl_section_break: false }
        },
        building_type: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: { table_view: "", remove_tbl_section_break: false }
        },
        additions: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                remove_tbl_section_break: false
            }
        },
        sorted_recom: {
            hasConfig: true,
            isVisible: true,
            defaultValue: {
                band1: {
                    is_soft_cost: false,
                    mfilter: {},
                    type: ["building"],
                    name: "Sorted Recommendation"
                }
            }
        },

        criticality: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                remove_tbl_section_break: false
            }
        },
        condition: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: { table_view: "", remove_tbl_section_break: false }
        },
        categories: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                remove_tbl_section_break: false
            }
        },
        funding_sources: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                remove_tbl_section_break: false
            }
        },
        priorities: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                remove_tbl_section_break: false
            }
        },
        trades: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                remove_tbl_section_break: false
            }
        },
        system: {
            hasConfig: true,
            config: {
                table_view: true,
                normal_recom: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                normal_recom: { band1: { mfilter: {}, remove_section_break: false }, name: "Recommendations", config_filter: {} },
                combination: false,
                remove_tbl_section_break: false
            }
        },
        subsystem: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                remove_tbl_section_break: false
            }
        },
        responsibilities: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                remove_tbl_section_break: false
            }
        },
        capital_type: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                remove_tbl_section_break: false
            }
        },
        energy_band: {
            hasConfig: true,
            isVisible: true,
            defaultValue: "",
            remove_section_break: false
        },
        water_band: {
            hasConfig: false,
            isVisible: true,
            defaultValue: ""
        },
        asset_band: {
            hasConfig: true,
            isVisible: true,
            defaultValue: { table_view: "", remove_tbl_section_break: false }
        },
        filter_report1: {
            hasConfig: false,
            isVisible: true,
            name: "Master Filters",
            band1: {
                mfilter: {}
            }
        },
        recommendation_status: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                remove_tbl_section_break: false
            }
        },
        building_addition_sf: {
            hasConfig: true,
            config: {
                table_view: true
            },
            isVisible: true,
            defaultValue: {
                table_view: "",
                remove_tbl_section_break: false
            }
        },
        table_of_contents: {
            name: "TABLE OF CONTENTS",
            remove_section_break: false,
            custom_heading_props: {
                bold: true,
                color: "003f2d",
                font_size: 20,
                font_id: "",
                bg_color: "ffffff",
                alignment: "center",
                cell_margin: {
                    top: 0.04,
                    left: 0.04,
                    right: 0.04,
                    bottom: 0.04
                }
            },
            structured_heading: {}
        },
        project_cost: {
            hasConfig: true,
            config: {
                table_view: true,
                show_columns: {
                    setting: true,
                    actual: true,
                    Setting: {
                        percentage: true,
                        value: true
                    },
                    Actual: {
                        percentage: true,
                        value: true
                    }
                }
            },
            isVisible: true,
            defaultValue: { table_view: "", remove_tbl_section_break: false }
        }
    },
    assets: {
        asset_band: {
            hasConfig: false,
            isVisible: true,
            defaultValue: { table_view: "" }
        },
        end_servicelife_year_condition: {
            hasConfig: false,
            isVisible: true,
            defaultValue: { table_view: "" }
        },
        asset_age_by_condition: {
            hasConfig: false,
            isVisible: true,
            defaultValue: { table_view: "" }
        },
        asset_capital_spending_plan: {
            hasConfig: false,
            isVisible: true,
            defaultValue: {
                table_view: ""
            }
        },
        asset_system_facility: {
            hasConfig: false,
            isVisible: true,
            defaultValue: { table_view: "" }
        }
    },
    energy_mng: {
        // em_eui_building_breakdown: {
        //     hasConfig: true,
        //     config: {
        //         detailed_view: true
        //     },
        //     isVisible: true,
        //     defaultValue: { detailed_view: { chart_type: ["stacked_column_2d"] } }
        // },
        // bld_brkdown_energy_usage: {
        //     hasConfig: true,
        //     config: {
        //         summary_view: true
        //     },
        //     isVisible: true,
        //     defaultValue: { summary_view: { chart_type: ["pie_2d"] } }
        // },
        // em_eui_site_brkdown_energy_use: {
        //     hasConfig: true,
        //     config: {
        //         detailed_view: true
        //     },
        //     isVisible: true,
        //     defaultValue: { detailed_view: { chart_type: ["stacked_column_2d"] } }
        // },
        // em_eui_energy_usage: {
        //     hasConfig: true,
        //     config: {
        //         summary_view: true
        //     },
        //     isVisible: true,
        //     defaultValue: { summary_view: { chart_type: ["pie_2d"] } }
        // },
        // bld_brkdown_energy_cost: { hasConfig: true, isVisible: true, defaultValue: { summary_view: { chart_type: ["pie_2d"] } } },
        // em_eci_site_cost: { hasConfig: true, isVisible: true, defaultValue: { detailed_view: { chart_type: ["stacked_column_2d"] } } },
        // em_eci_energy_cost: { hasConfig: true, isVisible: true, defaultValue: { summary_view: { chart_type: ["pie_2d", "pie_3d"] } } },
        energy_band: {
            hasConfig: false,
            isVisible: true,
            defaultValue: "",
            remove_section_break: false
        },
        water_band: {
            hasConfig: false,
            isVisible: true,
            defaultValue: ""
        }
    }
};

export const EXPORTING_CHART_SECTIONS = [
    { key: "header", label: "Header" },
    { key: "color_legend", label: "Color Legend" },
    { key: "legend", label: "Table Legend" },
    { key: "total", label: "Total Line" }
];

export const RECOM_FIRST_LEVEL_GROUPING = [
    {
        value: "region",
        name: "Region"
    },
    {
        value: "site",
        name: "Site"
    },
    {
        value: "building",
        name: "Building"
    },
    {
        value: "responsibility",
        name: "Responsibility"
    },
    {
        value: "category",
        name: "Category"
    },
    {
        value: "addition",
        name: "Addition"
    },
    {
        value: "project",
        name: "Project"
    },
    {
        value: "trade",
        name: "Trade"
    },
    {
        value: "system",
        name: "System"
    },
    {
        value: "subsystem",
        name: "Subsystem"
    },
    {
        value: "criticality",
        name: "Criticality"
    },
    {
        value: "fundingsource",
        name: "Funding source"
    },
    {
        value: "department",
        name: "Department"
    },
    {
        value: "floor",
        name: "Floor"
    },
    {
        value: "condition",
        name: "Condition"
    },
    {
        value: "capitaltype",
        name: "Capitaltype"
    },
    {
        value: "code",
        name: "Code"
    },
    {
        value: "status",
        name: "Status"
    }
];
export const RECOM_SECOND_LEVEL_GROUPING = [
    {
        value: "site",
        name: "Site"
    },
    {
        value: "building",
        name: "Building"
    }
];

export const taskStatus = [
    { value: "PENDING", class: "pending-task", color: "#e61607" },
    { value: "QUEUED", class: "queued-task", color: "#FFA500" },
    { value: "RUNNING", class: "running-task", color: "#006EFF" },
    { value: "COMPLETED", class: "completed-task", color: "#04B934" },
    { value: "FAILED", class: "pending-task", color: "#e61607" },
    { value: "CANCELLED", class: "pending-task", color: "#e61607" }
];

export const CoreReportGeohierarchy = [
    { label: "Region", key: "regions", paramKey: "region_ids" },
    { label: "Site", key: "sites", paramKey: "site_ids" },
    { label: "Building Types", key: "building_types", paramKey: "building_types" },
    { label: "Buildings", key: "buildings", paramKey: "building_ids" },
    { label: "Floor", key: "floors", paramKey: "floor_ids" },
    { label: "Addition", key: "additions", paramKey: "addition_ids" }
    // { label: "Trade", key: "trades", paramKey: "trade_ids" },
    // { label: "category", key: "category", paramKey: "category_ids" }
];
